import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { ApiClientService } from '@services/index';
import { UntilDestroy } from '@ngneat/until-destroy';
import { GetActivitiesResponse } from '@services/api-client/responses';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, debounceTime, map, merge, of, switchMap } from 'rxjs';
import { FilterRequest } from '@services/api-client/requests';
import { Activity } from 'app/types';
import { ActivityHelper } from 'app/features/shared/helper/activity';
import { Predicate, PredicateOperator } from 'app/enums';

export enum ViewType {
    Mine,
    All
}

@UntilDestroy()
@Component({
    selector: 'app-agreement-activity',
    templateUrl: './activity.component.html',
    styleUrl: './activity.component.scss'
})
export class AgreementActivityComponent implements OnInit {
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly apiClientService = inject(ApiClientService);
    private readonly route = inject(ActivatedRoute);
    private readonly activityHelper = inject(ActivityHelper);

    @Input() public agreementId: string;
    public selected = ViewType.All;
    public viewType = ViewType;

    private readonly getActivitiesSubject = new BehaviorSubject<FilterRequest>(null);
    public activities$ = this.getActivitiesSubject.pipe(
        //skip(1),
        debounceTime(250),
        switchMap((request) => {
            if (request) {
                return merge(
                    of(null),
                    this.apiClientService.getActivities$(request).pipe(
                        map((response: GetActivitiesResponse) => {
                            return response;
                        })
                    )
                );
            }
            return of(null);
        })
    );

    public ngOnInit() {
        this.getActivitiesSubject.next(this.getFilter());
    }

    public getActivityText(activity: Activity) {
        return this.activityHelper.getActivityText(activity);
    }

    public changeView(viewType: ViewType) {
        this.selected = viewType;
        console.log('Changing view to: ' + this.selected);
        this.getActivitiesSubject.next(this.getFilter());
    }

    private getFilter() {
        const predicates: Predicate<boolean | string>[] = [];
        const filter = { page: 1, pageSize: 10, predicates: predicates };
        if (this.agreementId) {
            predicates.push({
                propertyName: 'agreementId',
                operator: PredicateOperator.Equals,
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                value: `${this.agreementId}`
            });
        } else if (this.selected === ViewType.Mine) {
            predicates.push({
                propertyName: 'onlymine',
                operator: PredicateOperator.Equals,
                value: true
            });
        }
        return filter;
    }
}
